

















import { Component, Vue } from "vue-property-decorator";
import { getters, mutations } from "@/observables";

@Component({})
export default class extends Vue {
  /* Data */
  default = { id: 0, descricao: this.$t("common.all") } as TenderMixOperator.EquipGroup;
  equipGroup = this.default;

  /* Computed */
  get equipGroups() {
    return [this.default, ...getters.getEquipGroups()];
  }

  /* methods */
  onChange() {
    mutations.setEquipGroupSelected(this.equipGroup);
    this.$emit("change");
  }
}
